export default __webpack_public_path__ + "static/media/addIcon.9be4b20c.svg";